import { FC } from 'react';
import { CSSTransition } from 'react-transition-group';

import { Button } from '#/components/Button/Button';
import { tb } from '#/store/translation/translation.store';

import {
  SubscribeWithoutPaymentProps,
  useSubscribeWithoutPayment,
} from './SubscribeWithoutPayment.hook';
import {
  Container,
  Line,
  LineWrapper,
  Text,
} from './SubscribeWithoutPayment.styled';

export const SubscribeWithoutPayment: FC<SubscribeWithoutPaymentProps> = ({
  selectedProduct,
  voucherCode,
  isPaymentDetailsRequired,
  onPaymentComplete,
  giftCode,
  voucherRedeemed,
  onVoucherRedeemed,
}) => {
  const {
    isLoading,
    onStartSubscriptionWithoutPaymentDetails,
    enableSubscribeWithoutPaymentDetails,
  } = useSubscribeWithoutPayment({
    selectedProduct,
    voucherCode,
    isPaymentDetailsRequired,
    onPaymentComplete,
    giftCode,
    voucherRedeemed,
    onVoucherRedeemed,
  });

  return (
    <CSSTransition
      in={enableSubscribeWithoutPaymentDetails}
      mountOnEnter={true}
      timeout={500}
      unmountOnExit={false}
    >
      <Container>
        <Text>{tb('web.iap.voucher.fullDiscount.description')}</Text>
        <Button
          isFullWidth
          isLoading={isLoading}
          onClick={onStartSubscriptionWithoutPaymentDetails}
        >
          {tb('web.iap.voucher.fullDiscount.subscribeButton')}
        </Button>
        <LineWrapper>
          <Line />
          <Text $margin="0 1rem">{tb('web.iap.voucher.fullDiscount.or')}</Text>
          <Line />
        </LineWrapper>
        <Text $margin="0 0 1.5rem 0">
          {tb('web.iap.voucher.fullDiscount.creditCardDescription')}
        </Text>
      </Container>
    </CSSTransition>
  );
};
